var BaseView = require('./abstract/template');
var ProjectFacade = require('../../../../facade/project/project');

module.exports = BaseView.extend({
  height: null,
  template: require('./templates/template.hbs'),
  addEvent: $.noop,

  initialize: function (options) {
    BaseView.prototype.initialize.call(this);

    this.width = options.width;
    this.format = options.format;
    this.design = options.design;
    this.isCustomFormat = options.isCustomFormat;

    this.render();
    this.initImageLoad();
  },

  getTemplateRenderData: function () {
    return this.getFormatRenderData();
  },

  getFormatRenderData: function () {
    var twoLinesDescriptionHeight = 56;
    var ratio = this.format['thumb_width']
      ? this.format['thumb_width'] / this.format['thumb_height']
      : this.format['width'] / this.format['height'];

    var thumbHeight = this.width * (1 / ratio);

    return _.extend(this.format, {
      url: this.format['url'] || this.format['thumbnail'],
      is_single_line: thumbHeight < twoLinesDescriptionHeight,
      thumb_width: Math.floor(this.format['thumb_width'] || this.format['width']),
      thumb_height: Math.floor(thumbHeight)
    });
  },

  initImageLoad: function () {
    var isCustomFormat = this.isCustomFormat;

    this.$el.find('img').each(function () {
      this.onload = onImageLoad;
      this.src = $(this).data('src');
    });

    function onImageLoad () {
      var $image = $(this);
      $image.closest('.thumbnail.image')
        .removeClass('loading');

      if (isCustomFormat) {
        var $thumbnail = $image.parent();
        $thumbnail.height($image.height()).addClass('custom');
        $thumbnail.width() > $image.width() && $image.width($thumbnail.width())
          .removeAttr('height');
      } else if (this.src.split('/').pop() !== 'blank.jpg') {
        $image.removeAttr('height');
      }
    }
  }
});
